import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../api/api';
import logo from "../Assets/lo.png"
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
        const response = await loginUser(username, password);
        toast.success("Login successful!");
        console.log('Login successful:', response);
        localStorage.setItem('isAuthenticated', 'true');
        navigate('/admin');
      } catch (err) {
        setError('Login failed. Please check your credentials.');
        toast.error('Login failed! Please check your credentials.');
        console.error(err);
      }
       finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#202020] via-[#181818] to-[#191919] text-white">
      <div className="w-full max-w-5xl flex  overflow-hidden bg-white bg-opacity-10 backdrop-blur-md shadow-xl p-8 rounded-2xl border border-white border-opacity-20 mb-4 text-black">
        {/* Left Logo Section */}
        <div className="w-1/2  flex  flex-col items-center justify-center p-10">
          <img
            src={logo}
            alt="Logo"
            className="w-96 h-auto"
          />
              <h1 className="md:text-3xl text-2xl  text-center pt-4 pb-3 font-bold bg-gradient-to-r from-[#00DE6D] to-[#00ACDC] bg-clip-text text-transparent">
              Essential Packages
            </h1>
        </div>
  
        {/* Right Login Form Section */}
        <div className="w-1/2 text-white  p-10">
          <h2 className="text-3xl font-bold mb-6 text-center">Admin Login</h2>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block mb-1 text-sm">Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="w-full bg-black bg-opacity-10 border outline-none text-white p-2 rounded-md"
              />
            </div>
            <div>
              <label className="block mb-1 text-sm">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full bg-black bg-opacity-10 border outline-none text-white p-2 rounded-md"

              />
            </div>
            {error && <p className="text-red-500 text-sm">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2 rounded bg-gradient-to-r from-[#00DE6D] to-[#00ACDC] text-white font-semibold hover:opacity-90 transition"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
